import colors from './colors';

export enum AlignType {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right'
}

export enum IconPosition {
  LEFT = 'left',
  RIGHT = 'right'
}

export const scroller = ` 
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  
  ::-webkit-scrollbar-track {
    background: ${colors.bottomBorderColor};
    border-radius: 20px;
  }
  
  ::-webkit-scrollbar-thumb {
    background: ${colors.main2};
    border-radius: 20px;
  }
`;

export const debounce = (callback, wait) => {
  let timeout: number;
  return (...args) => {
    const next = () => callback(...args);
    clearTimeout(timeout);
    timeout = setTimeout(next, wait);
  };
};
